import { ORDER_HISTORY_PROPERTY_DATA_API } from '../constants/AppConstants';

/**
 * Service to get property data for multiple report IDs
 * @param {Array<number>} reportIds - Array of report IDs
 * @returns {Promise} - API response promise with property data for each report ID
 */
const orderHistoryPropertyDataService = async (reportIds) => {
  const requestBody = {
    reportIds,
  };

  try {
    const response = await fetch(ORDER_HISTORY_PROPERTY_DATA_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json, status: response.status };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default orderHistoryPropertyDataService;
